import "@fontsource-variable/inter";
import { initFaro } from "@/faro";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

// Initialize frontend observability before the app mounts so early errors and
// navigation timings are captured.
initFaro();
import { HelmetProvider } from "react-helmet-async";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import App from "@/App";
import { ThemeContextProvider } from "@/theme/ThemeContext";
import { AuthProvider } from "@/contexts/AuthContext";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeContextProvider>
        <HelmetProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <AuthProvider>
              <App />
            </AuthProvider>
          </LocalizationProvider>
        </HelmetProvider>
      </ThemeContextProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
